import { render } from "./NewSupportTicket.vue?vue&type=template&id=5a0ebf95&scoped=true"
import script from "./NewSupportTicket.vue?vue&type=script&lang=js"
export * from "./NewSupportTicket.vue?vue&type=script&lang=js"

import "./NewSupportTicket.vue?vue&type=style&index=0&id=5a0ebf95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0ebf95"],['__file',"src/views/External/NewSupportTicket.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a0ebf95"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a0ebf95', __exports__)) {
    api.reload('5a0ebf95', __exports__)
  }
  
  module.hot.accept("./NewSupportTicket.vue?vue&type=template&id=5a0ebf95&scoped=true", () => {
    api.rerender('5a0ebf95', render)
  })

}


export default __exports__